import Vue from 'vue'
import Router from 'vue-router'
import Users from '../views/Users'
import About from '../views/About'
import Home from '../views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  //   base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'management',
    component: 
    Home,
    Users,
    About
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: About
  },
  {
    path: '/users',
    name: 'users',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Users
  },
  ]
})